
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privatlivspolitik",
      function () {
        return require("private-next-pages/privatlivspolitik/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privatlivspolitik"])
      });
    }
  